// LinkedIn posts - repurposed from the articles, matching the organic plan:
// 2 posts/week, alternate a plain-English tip with a career story, end with the checklist link.
// Replace [checklist link] with https://claruspartners.com.au/xero-health-check

export const LINKEDIN_POSTS = [
  {
    id: "li-trades",
    title: "Post 1 - Trades (from 'Why your Xero file never matches the bank')",
    note: "Tip post. Best posted Tue-Thu morning. Reply to every comment in the first hour.",
    body: `Your Xero says $47,000. Your banking app says $31,000.

Somewhere between those two numbers is a Saturday afternoon you'll never get back.

After 15+ years in finance, I can tell you the gap almost always comes down to five things:

1. The bank feed is connected but nobody has actually reconciled it in months
2. A bank rule set up once, misfiring ever since (everything coded to "materials")
3. A suspense account that's become a junk drawer
4. Business and personal spending mixed together
5. Old invoices and bills that were paid but never cleared

None of these are hard to fix. All of them get more expensive the longer they sit - because your accountant can't lodge off a file that doesn't reconcile, and every hour they spend untangling it is an hour you pay for.

I put the 15 checks I run before any clean-up into a free one-page checklist. It takes about 20 minutes and you'll know exactly which zone your file is in.

Grab it here: [checklist link]

#trades #smallbusiness #xero #bookkeeping`,
  },
  {
    id: "li-startups",
    title: "Post 2 - Startups (from 'The numbers investors actually ask for')",
    note: "Tip post. Founders scroll LinkedIn in the evening - try a 5-7pm slot.",
    body: `"So what's your burn?"

Every founder has had the moment. The investor leans in, and the answer involves three spreadsheets and the word "roughly".

Here's what I've learned after years on both sides of that table: the numbers investors actually ask for are a short list.

Burn rate. Runway. MRR (the honest version, not one-off fees in disguise). Gross margin. And the gap between your revenue and your cash.

None of them live in a spreadsheet you maintain at midnight. They all fall out of your accounting file - IF it's reconciled monthly and coded properly.

The founders who answer investor questions in one email aren't doing more preparation. Their books already carry the answer.

If you're heading into a raise or a grant application this year, the cheapest diligence prep there is: make sure your file could answer those five questions today.

I made a free 15-point checklist that tells you in about 20 minutes: [checklist link]

#startups #fundraising #xero #fractionalcfo`,
  },
  {
    id: "li-service",
    title: "Post 3 - Service businesses (from 'Which of your clients actually makes you money?')",
    note: "Story-style post. The 'biggest client, worst client' hook earns comments - have a reply ready with the checklist link.",
    body: `Your biggest client is probably not your best client.

I see this pattern constantly in service businesses:

The largest account gets the most attention, the most scope creep, the most "quick favours", and the slowest payment terms.

Meanwhile a mid-sized client who pays on time, stays in scope and never calls after hours quietly delivers twice the margin.

The fix isn't a new CRM. It's three numbers, per client:

1. Revenue (easy - it's in your sales report)
2. Direct delivery cost (harder - wages and contractors need to be coded to the client, not dumped in general expenses)
3. Hours (even rough ones turn the first two into an effective hourly rate)

That effective hourly rate is the most honest scorecard a service business has. Once you see it per client, the decisions make themselves: reprice the creepers, clone the great ones, and have the honest conversation with the rest.

I wrote up how to set this up in Xero - link in the comments. And if you want to know what shape your file is in first, my free 15-point health check is here: [checklist link]

#smallbusiness #agencylife #consulting #xero`,
  },
];


export const EMAIL_TEMPLATES = [
  {
    id: "quarterly-review",
    title: "Quarterly client review (with upgrade prompt)",
    note: "Send at the end of each quarter. Pull the client's transaction count from the Xero Transaction Detail report first - if they are near or over their plan cap, this email opens the upgrade conversation without it feeling like a bill shock.",
    subject: "Your quarterly numbers review - [Business name]",
    body: `Hi [First name],

Quick review of the quarter for [Business name].

What went well:
- [e.g. Books closed by the 5th each month / BAS lodged with zero queries from your accountant / invoices going out same-day]

Your numbers at a glance:
- Revenue: $[amount] ([up/down] [x]% on last quarter)
- [One plain-English observation, e.g. "Wages are creeping up as a share of revenue - worth watching"]

Your plan usage:
You're on the [Plan] plan. This quarter you ran about [x] transactions a month, which is [within / close to / over] your plan's [cap]. [If over or close: "Rather than let the work pile up, the cleanest fix is moving you to [higher plan] at $[x]/month - that adds [headline benefit]. Happy to talk it through."]

Next quarter's focus:
- [One thing, e.g. "Getting the 13-week cashflow forecast set up before the busy season"]

Anything on your mind? Reply here or grab 15 minutes: [Calendly link]

- Nima`,
  },
  {
    id: "referral-ask",
    title: "Referral ask (after a successful clean-up)",
    note: "Send 1-2 weeks after a Clean-Up Sprint handover, when the relief is fresh.",
    subject: "Quick favour - who do you know with a messy Xero file?",
    body: `Hi [First name],

Glad we got [Business name]'s file cleaned up and your accountant lodging again.

Quick favour: who do you know - a mate in the trades, a founder, another business owner - whose books are a mess or months behind? Most of my clients come from exactly that introduction.

If someone comes to mind, feel free to forward this or send them my way. Their first step is a free Xero Health Check, so there's no cost and no risk in the referral.

Thanks either way - and thanks for being great to work with.

- Nima`,
  },
  {
    id: "accountant-partner",
    title: "Tax accountant partnership intro",
    note: "Send to 2-3 local or online tax accountants. They see the messy files first; you make their lodgements painless; they send the clean-up work to you. This is your highest-quality channel.",
    subject: "Cleaner files for your lodgements - a partnership offer",
    body: `Hi [Name],

I'm Nima Riazati, a CPA running Clarus Partners - remote Xero clean-ups and ongoing bookkeeping for small businesses across Australia.

The short version: I take your clients with messy or behind Xero files, bring everything up to date and accountant-ready, and hand you a file you can lodge without the back-and-forth. I don't lodge anything myself - tax and BAS stay entirely with you.

For you: faster lodgements, fewer messy-file headaches, and happier clients.
For your clients: fixed-price clean-ups and honest monthly plans.
For me: a steady source of the work I do best.

Worth a 15-minute call to see if a referral arrangement makes sense? [Calendly link]

- Nima Riazati, CPA
Clarus Partners - claruspartners.com.au`,
  },
];
